import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { useEmbeddedEditorContext } from 'campaigns-lib/embedded/EmbeddedEditorContext';
import EmbeddedEditorWrapper from 'campaigns-lib/embedded/EmbeddedEditorWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function CopilotInner({
  children,
  copilotEnabled,
  CopilotCollaborationContextProviderComponent
}) {
  const {
    isInsideMarketingStudio
  } = useEmbeddedEditorContext();
  if (copilotEnabled) {
    if (CopilotCollaborationContextProviderComponent) {
      children = /*#__PURE__*/_jsx(CopilotCollaborationContextProviderComponent, {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(CopilotProvider, {
      createLayer: isInsideMarketingStudio,
      children: children
    });
  }
  return children;
}
const MaybeCopilotWrapper = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(EmbeddedEditorWrapper, {
    children: /*#__PURE__*/_jsx(CopilotInner, Object.assign({}, props))
  });
};
export default MaybeCopilotWrapper;